import localStore from "store2";

import { IKeyValue } from "models/commonModel";

export const getSetting = (key: string): string => {
    const configs: IKeyValue<string> = localStore.get(process.env.REACT_APP_LOCAL_STORAGE_SETTINGS);
    if (configs) {
        if (configs[key]) {
            return configs[key];
        }
    }
    return process.env[key]!!;
};

export const API_BASE_URI = getSetting('REACT_APP_API_BASE_URI');
export const RESOURCES_EXPIRATION_TIME = +getSetting('REACT_APP_RESOURCES_EXPIRATION_TIME');
export const LOAD_RESOURCES_PATH = getSetting('REACT_APP_LOAD_RESOURCES_PATH');
export const RESOURCES_VERSION = getSetting('REACT_APP_RESOURCES_VERSION');
export const AUTHORITY = getSetting('REACT_APP_AUTHORITY');
export const CLIENT_ID = getSetting('REACT_APP_CLIENT_ID');
export const REDIRECT_URI = getSetting('REACT_APP_REDIRECT_URI');
export const SILENT_REDIRECT_URI = getSetting('REACT_APP_SILENT_REDIRECT_URI');
export const SCOPE = getSetting('REACT_APP_SCOPE');
export const ACCESS_TOKEN_EXPIRATION_SECONDS = +getSetting('REACT_APP_ACCESS_TOKEN_EXPIRING_NOTIFICATION_TIME');
export const REQUEST_FILE_SIZE_LIMIT = +getSetting('REACT_APP_REQUEST_FILE_SIZE_LIMIT');
export const WHATSAPP_TEMPLATES_PAGE_SIZE = +getSetting('REACT_APP_WHATSAPP_TEMPLATES_PAGE_SIZE');
export const LIST_DEFAULT_STALE_TIME = +getSetting('REACT_APP_LIST_DEFAULT_STALE_TIME');
export const TEMPLATE_HEADER_FILE_MAX_SIZE = +getSetting('REACT_APP_TEMPLATE_HEADER_FILE_MAX_SIZE');
export const CHATBOT_SESSION_DEFAULT_LIFETIME = +getSetting('REACT_APP_CHATBOT_SESSION_DEFAULT_LIFETIME');
export const SMS_SENDER_NAME_REGEX_PATTERN = getSetting('REACT_APP_SMS_SENDER_NAME_REGEX_PATTERN');
export const MESSAGE_LINK_PREFILLED_MAX_LENGTH = getSetting('REACT_APP_MESSAGE_LINK_PREFILLED_MAX_LENGTH');
export const ACCOUNT_CREDIT_ADDITIONS_PAGE_SIZE = +getSetting('REACT_APP_ACCOUNT_CREDIT_ADDITIONS_PAGE_SIZE');
export const ACCOUNT_PACKAGE_PAGE_SIZE = +getSetting('REACT_APP_ACCOUNT_PACKAGE_PAGE_SIZE');
export const ADDRESS_BOOK_CONTACTS_PAGE_SIZE = +getSetting('REACT_APP_ADDRESS_BOOK_CONTACTS_PAGE_SIZE');
export const ADDRESS_BOOK_CONTACTS_UPLOAD_SAMPLE_FILE_URL = getSetting('REACT_APP_ADDRESS_BOOK_CONTACTS_UPLOAD_SAMPLE_FILE_URL');
export const CAMPAIGN_PAGE_SIZE = +getSetting('REACT_APP_CAMPAIGNS_PAGE_SIZE');
export const BLOCKED_NUMBERS_PAGE_SIZE = +getSetting('REACT_APP_WHATSAPP_BLOCKED_NUMBERS_PAGE_SIZE');
export const SALLA_REDIRECT_URI = getSetting('REACT_APP_SALLA_REDIRECT_URI');
export const POSTHOG_PUBLIC_KEY = getSetting('REACT_APP_POSTHOG_PUBLIC_KEY');
export const POSTHOG_PUBLIC_HOST = getSetting('REACT_APP_POSTHOG_PUBLIC_HOST');
export const TEMPLATE_MEDIA_IMAGE_FILE_SIZE_LIMIT = getSetting('REACT_APP_TEMPLATE_MEDIA_IMAGE_FILE_SIZE_LIMIT');
export const TEMPLATE_MEDIA_VIDEO_FILE_SIZE_LIMIT = getSetting('REACT_APP_TEMPLATE_MEDIA_VIDEO_FILE_SIZE_LIMIT');
export const TEMPLATE_MEDIA_DOCUMENT_FILE_SIZE_LIMIT = getSetting('REACT_APP_TEMPLATE_MEDIA_DOCUMENT_FILE_SIZE_LIMIT');
export const TEMPLATE_MEDIA_IMAGE_FILE_ACCEPTED_FORMAT = getSetting('REACT_APP_TEMPLATE_MEDIA_IMAGE_FILE_ACCEPTED_FORMAT');
export const TEMPLATE_MEDIA_VIDEO_FILE_ACCEPTED_FORMAT = getSetting('REACT_APP_TEMPLATE_MEDIA_VIDEO_FILE_ACCEPTED_FORMAT');
export const TEMPLATE_MEDIA_DOCUMENT_FILE_ACCEPTED_FORMAT = getSetting('REACT_APP_TEMPLATE_MEDIA_DOCUMENT_FILE_ACCEPTED_FORMAT');
export const ZID_REDIRECT_URI = getSetting('REACT_APP_Zid_REDIRECT_URI');
export const GTM_CONTAINER_ID = getSetting('REACT_APP_GTM_CONTAINER_ID');
export const SALES_EMAIL = getSetting('REACT_APP_SALES_EMAIL');
export const RECAPTCHA_SITE_KEY = getSetting('REACT_APP_RECAPTCHA_SITE_KEY');
export const TAP_PAYMENT_PUBLIC_KEY = getSetting('REACT_APP_TAP_PAYMENT_PUBLIC_KEY');
export const TAP_PAYMENT_MERCHANT_ID = getSetting('REACT_APP_TAP_PAYMENT_MERCHANT_ID');
export const TRANSACTION_PAGE_SIZE = +getSetting('REACT_APP_TRANSACTION_PAGE_SIZE');
export const TRANSACTION_SNAPSHOT_PAGE_SIZE = +getSetting('REACT_APP_TRANSACTION_SNAPSHOT_PAGE_SIZE');
export const INSTAGRAM_OAUTH_URL = getSetting('REACT_APP_INSTAGRAM_OAUTH_URL');
export const REACT_APP_FRESH_WORK_WIDGET_ID = getSetting('REACT_APP_FRESH_WORK_WIDGET_ID');
export const DEVELOPERS_DOCS_URL = getSetting('REACT_APP_DEVELOPERS_DOCS_URL');
export const CHATBOT_URL = getSetting('REACT_APP_CHATBOT_URL');
export const AI_VOICE_AGENT_URL = getSetting('REACT_APP_AI_VOICE_AGENT_URL');
export const EMAIL_TO_CHANNEL_ACTIVATION_EMAIL = getSetting('REACT_APP_EMAIL_TO_CHANNEL_ACTIVATION_EMAIL');
